import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import {
  VarianteProdutoCardapioDTO,
  VarianteProdutoCardapioConsultaDTO,
  ReordenarDTO,
} from '../../models/cardapio-minishop/cardapio-minishop.model';

@Injectable({
  providedIn: 'root',
})
export class CardapioMinishopVarianteService {

  private readonly basePath = '/api/variante-produto-cardapio';

  constructor(private apiService: ApiService) {}

  listar(produtoId: number): Observable<VarianteProdutoCardapioConsultaDTO[]> {
    return this.apiService.read<VarianteProdutoCardapioConsultaDTO[]>(
      `${this.basePath}?produtoId=${produtoId}`
    );
  }

  buscarPorId(id: number): Observable<VarianteProdutoCardapioConsultaDTO> {
    return this.apiService.read<VarianteProdutoCardapioConsultaDTO>(
      `${this.basePath}/${id}`
    );
  }

  criar(data: VarianteProdutoCardapioDTO): Observable<VarianteProdutoCardapioConsultaDTO> {
    return this.apiService.create<VarianteProdutoCardapioConsultaDTO>(this.basePath, data);
  }

  atualizar(id: number, data: VarianteProdutoCardapioDTO): Observable<VarianteProdutoCardapioConsultaDTO> {
    return this.apiService.update<VarianteProdutoCardapioConsultaDTO>(`${this.basePath}/${id}`, data);
  }

  remover(id: number): Observable<any> {
    return this.apiService.delete(`${this.basePath}/${id}`);
  }

  reordenar(dto: ReordenarDTO): Observable<any> {
    return this.apiService.patch(`${this.basePath}/reordenar`, dto);
  }
}
